// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AppBannerController from "./app_banner_controller"
application.register("app-banner", AppBannerController)

import AppDownloadController from "./app_download_controller"
application.register("app-download", AppDownloadController)

import AutogrowController from "./autogrow_controller"
application.register("autogrow", AutogrowController)

import AutosubmitController from "./autosubmit_controller"
application.register("autosubmit", AutosubmitController)

import BackController from "./back_controller"
application.register("back", BackController)

import Bridge__ActionSheetController from "./bridge/action_sheet_controller"
application.register("bridge--action-sheet", Bridge__ActionSheetController)

import Bridge__AuthGateController from "./bridge/auth_gate_controller"
application.register("bridge--auth-gate", Bridge__AuthGateController)

import Bridge__ButtonController from "./bridge/button_controller"
application.register("bridge--button", Bridge__ButtonController)

import Bridge__ConfirmController from "./bridge/confirm_controller"
application.register("bridge--confirm", Bridge__ConfirmController)

import Bridge__FavoriteController from "./bridge/favorite_controller"
application.register("bridge--favorite", Bridge__FavoriteController)

import Bridge__FormController from "./bridge/form_controller"
application.register("bridge--form", Bridge__FormController)

import Bridge__HapticController from "./bridge/haptic_controller"
application.register("bridge--haptic", Bridge__HapticController)

import Bridge__ListActionsController from "./bridge/list_actions_controller"
application.register("bridge--list-actions", Bridge__ListActionsController)

import Bridge__MenuController from "./bridge/menu_controller"
application.register("bridge--menu", Bridge__MenuController)

import Bridge__MerchantLinkController from "./bridge/merchant_link_controller"
application.register("bridge--merchant-link", Bridge__MerchantLinkController)

import Bridge__NativeTokenController from "./bridge/native_token_controller"
application.register("bridge--native-token", Bridge__NativeTokenController)

import Bridge__OauthController from "./bridge/oauth_controller"
application.register("bridge--oauth", Bridge__OauthController)

import Bridge__ParentScreenController from "./bridge/parent_screen_controller"
application.register("bridge--parent-screen", Bridge__ParentScreenController)

import Bridge__PhotoPickerController from "./bridge/photo_picker_controller"
application.register("bridge--photo-picker", Bridge__PhotoPickerController)

import Bridge__PullToRefreshController from "./bridge/pull_to_refresh_controller"
application.register("bridge--pull-to-refresh", Bridge__PullToRefreshController)

import Bridge__PushController from "./bridge/push_controller"
application.register("bridge--push", Bridge__PushController)

import Bridge__ReviewController from "./bridge/review_controller"
application.register("bridge--review", Bridge__ReviewController)

import Bridge__SearchController from "./bridge/search_controller"
application.register("bridge--search", Bridge__SearchController)

import Bridge__ShareController from "./bridge/share_controller"
application.register("bridge--share", Bridge__ShareController)

import Bridge__SortController from "./bridge/sort_controller"
application.register("bridge--sort", Bridge__SortController)

import Bridge__TabAvatarController from "./bridge/tab_avatar_controller"
application.register("bridge--tab-avatar", Bridge__TabAvatarController)

import Bridge__TabBadgeController from "./bridge/tab_badge_controller"
application.register("bridge--tab-badge", Bridge__TabBadgeController)

import Bridge__TabReselectController from "./bridge/tab_reselect_controller"
application.register("bridge--tab-reselect", Bridge__TabReselectController)

import Bridge__TermsGateController from "./bridge/terms_gate_controller"
application.register("bridge--terms-gate", Bridge__TermsGateController)

import Bridge__ThemeController from "./bridge/theme_controller"
application.register("bridge--theme", Bridge__ThemeController)

import Bridge__ToastController from "./bridge/toast_controller"
application.register("bridge--toast", Bridge__ToastController)

import CarouselController from "./carousel_controller"
application.register("carousel", CarouselController)

import CategoryPickerController from "./category_picker_controller"
application.register("category-picker", CategoryPickerController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import CoverPositionController from "./cover_position_controller"
application.register("cover-position", CoverPositionController)

import CsrfRefreshController from "./csrf_refresh_controller"
application.register("csrf-refresh", CsrfRefreshController)

import DetailsScrollController from "./details_scroll_controller"
application.register("details-scroll", DetailsScrollController)

import DialogController from "./dialog_controller"
application.register("dialog", DialogController)

import DialogOpenerController from "./dialog_opener_controller"
application.register("dialog-opener", DialogOpenerController)

import FadeUpController from "./fade_up_controller"
application.register("fade-up", FadeUpController)

import FlashController from "./flash_controller"
application.register("flash", FlashController)

import FloatingActionsController from "./floating_actions_controller"
application.register("floating-actions", FloatingActionsController)

import FooterAccordionController from "./footer_accordion_controller"
application.register("footer-accordion", FooterAccordionController)

import GodsFormController from "./gods_form_controller"
application.register("gods-form", GodsFormController)

import GridController from "./grid_controller"
application.register("grid", GridController)


import HtmlPreviewController from "./html_preview_controller"
application.register("html-preview", HtmlPreviewController)

import ImagePreviewController from "./image_preview_controller"
application.register("image-preview", ImagePreviewController)

import InfinitePaginationController from "./infinite_pagination_controller"
application.register("infinite-pagination", InfinitePaginationController)

import InlineEditController from "./inline_edit_controller"
application.register("inline-edit", InlineEditController)

import LinkController from "./link_controller"
application.register("link", LinkController)

import LocationReplaceController from "./location_replace_controller"
application.register("location-replace", LocationReplaceController)

import NotificationsController from "./notifications_controller"
application.register("notifications", NotificationsController)

import NotificationsSeenController from "./notifications_seen_controller"
application.register("notifications-seen", NotificationsSeenController)

import OpenModalOnConnectController from "./open_modal_on_connect_controller"
application.register("open-modal-on-connect", OpenModalOnConnectController)

import ParamAutoclickController from "./param_autoclick_controller"
application.register("param-autoclick", ParamAutoclickController)

import PasswordController from "./password_controller"
application.register("password", PasswordController)

import PreloadController from "./preload_controller"
application.register("preload", PreloadController)

import RemovalPreviewController from "./removal_preview_controller"
application.register("removal-preview", RemovalPreviewController)

import RichEditorController from "./rich_editor_controller"
application.register("rich-editor", RichEditorController)

import ScraperController from "./scraper_controller"
application.register("scraper", ScraperController)

import ScrollMemoryController from "./scroll_memory_controller"
application.register("scroll-memory", ScrollMemoryController)

import SearchController from "./search_controller"
application.register("search", SearchController)

import SearchTitleController from "./search_title_controller"
application.register("search-title", SearchTitleController)

import SeeMoreController from "./see_more_controller"
application.register("see-more", SeeMoreController)

import SelectionController from "./selection_controller"
application.register("selection", SelectionController)

import SlowLoadController from "./slow_load_controller"
application.register("slow-load", SlowLoadController)

import SortableController from "./sortable_controller"
application.register("sortable", SortableController)

import TabsController from "./tabs_controller"
application.register("tabs", TabsController)

import ThemeController from "./theme_controller"
application.register("theme", ThemeController)

import TooltipController from "./tooltip_controller"
application.register("tooltip", TooltipController)

import TurboModalController from "./turbo_modal_controller"
application.register("turbo-modal", TurboModalController)

import User__NicknameController from "./user/nickname_controller"
application.register("user--nickname", User__NicknameController)

import User__RegistrationController from "./user/registration_controller"
application.register("user--registration", User__RegistrationController)

import WebShareController from "./web_share_controller"
application.register("web-share", WebShareController)
